import BaseFilter from "@shared/components/filters/BaseFilter.jsx";

export default function FilterPickups({ onFilter, currentFilters = {} }) {
  // Pickup status options for tabs
  const statusOptions = [
    { value: "order_received", label: "status.order_received" },
    { value: "signed", label: "status.signed" },
    { value: "return_collection", label: "status.return_collection" },
  ];

  // Configuration for pickup filtering
  const config = {
    showPhoneFilter: false, // Pickups typically don't filter by phone
    showCityFilter: true,
    showUserFilter: true,
    showDateRangeFilter: true,
    phoneFieldName: "customer.phone_q",
    cityFieldName: "pickupCity", // Filter by pickupCity field
    phonePlaceholder: "0600000000",
    entityName: "pickups",
    maxTabCols: 4, // Fewer status options for pickups
  };

  return (
    <BaseFilter
      onFilter={onFilter}
      currentFilters={currentFilters}
      statusOptions={statusOptions}
      config={config}
    />
  );
}
